
import Vue from 'vue';
// https://tahazsh.com/vuebyte-change-page-title
// Deje esto porque cuando uno revisa el historial, no sabe que pantalla es

const titles = {
    billing: "Selecciona tu cuenta",
    error: "Error al procesar tu pago",
    invoice: "Pago realizado con éxito",
    payment: "Paga tu cuenta"
}

Vue.mixin({
    created: function() {
        let title = "Portal de pagos VTR";
        if (this.$route !== undefined && 
            this.$route.name !== null && 
            titles[this.$route.name] !== undefined) {
           title = title + " - " + titles[this.$route.name];
        }
        document.title = title;
    }
});

  
  